import React, { useEffect } from "react";
import { useUserDetailContext } from "../../UserDetailContext";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getNoOfCardCountReducer } from "../../../Redux/Reducers/CardReducer";

const NoOfCards = () => {

    const dispatch = useDispatch();
    const activeCardCount = useSelector((state) => state?.CardArray?.NoOfCardCount?.active_cards
    );

    const inactiveCardCount = useSelector((state) => state?.CardArray?.NoOfCardCount?.inactive_cards
    );

    const totalCardCount = useSelector((state) => state?.CardArray?.NoOfCardCount?.total_cards

    );

    // const { userDetails, setFavoriteCards, setUserDetails, setCards, groupCardDetails, cards, localStoreUserDetails } = useUserDetailContext();
    useEffect(() => {
        dispatch(getNoOfCardCountReducer());
    }, [])
    return (
        <div className="sec-box-heightCommon px-5 py-3 ">
            <div className="d-flex align-items-center justify-content-between">
                <div>
                    <p className="card-title mt-0">No. of cards</p>
                    <p className="count-value mb-2 text-center">{totalCardCount || 0}</p>
                </div>
                <div >
                    <p className="card-title mt-0">Active</p>
                    <p className="count-cont mb-2 text-center">{activeCardCount || 0}</p>
                </div>
                <div >
                    <p className="card-title mt-0">Inactive</p>
                    <p className="count-cont-1 mb-2 text-center">{inactiveCardCount || 0}</p>
                </div>

            </div>
        </div>
    );

};
export default NoOfCards;